import { Examples } from '@/types';

export const ExampleMStoreAccordionRoutes =
  process.env.NODE_ENV !== 'production'
    ? [
      {
        ...Examples.ExampleMStoreAccordion,
        components: {
          default: () => import(/* webpackChunkName: "ExampleMStoreAccordion" */ 
          '@/views/examples/ExampleMStoreAccordion.vue')
        }
      }
    ]
    : [];
